import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Langs from "../../app/lang/langs";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import styles from "./ClientsView.module.css"
import { useDispatch, useSelector } from "react-redux";
import { addEditClient, getClients } from "../../components/clients/clientsSlice";

export default function AddClientModal(props) {

    const dispatch = useDispatch();

    const isMobile = useSelector((state) => state.settings.isMobile)

    const [name, setName] = useState('');
    const [vfact, setVfact] = useState('');
    const [inputStyle, setInputStyle] = useState(false)

    const handleAddClient = (name) => {
        if (name.trim() !== '' && vfact.trim() !== '') {
            dispatch(addEditClient({ name: name, vfact: vfact })).then((response) => {
                const responseData = response.payload.responseData
                if (responseData && responseData.status == 1) {
                    dispatch(getClients())
                }
            })
            handleClose()
        } else if (name.trim() !== '') {
            dispatch(addEditClient({ name: name })).then((response) => {
                const responseData = response.payload.responseData
                if (responseData && responseData.status == 1) {
                    dispatch(getClients())
                }
            })
            handleClose()
        } else {
            setInputStyle(true)
        }
    }

    const handleClose = () => {
        props.setVisible(false);
        setInputStyle(false)
        setName('');
        setVfact('');
    }

    return (
        <Dialog
            visible={props.visible}
            style={{ width: isMobile === 1 ? "40%" : 'fit-content', maxHeight: isMobile === 2 ? "80vh" : "60vh", }}
            onHide={() => { if (!props.visible) return; handleClose() }}
            position="center"
            header={<Langs str='ADD_CLIENT' />}
            draggable={false}
            dismissableMask={false}
            width={'10rem'}
        >
            <Row style={{ maxHeight: isMobile === 2 ? "80vh" : "60vh", }}>
                <Col lg={12} xs={12} className="mt-4">
                    <label><strong><Langs str={"Nom"} /></strong></label>
                </Col>
                <Col lg={12} xs={12} className="mt-2 d-flex justify-content-center">
                    <InputText invalid={inputStyle} className={styles.inputTextFull} value={name} placeholder="Nom" onChange={(e) => setName(e.target.value)} />
                </Col>
                <Col lg={12} xs={12} className="mt-4">
                    <label><strong><Langs str={"V-FACT"} /></strong></label>
                </Col>
                <Col lg={12} xs={12} className="mt-2 d-flex justify-content-center">
                    <InputText className={styles.inputTextFull} value={vfact} placeholder="V-FACT" onChange={(e) => setVfact(e.target.value)} />
                </Col>
                <Col lg={12} xs={12} className="mt-4 d-flex justify-content-center">
                    <Col lg={3} >
                        <DynamicButton
                            onClick={() => handleAddClient(name)}
                            className=''
                            title={<Langs str="ADD" />}
                            active={true}
                            color="green"
                        />
                    </Col>
                </Col>
            </Row>
        </Dialog>
    )
}